import Vue from 'vue'
import Router from 'vue-router'

// Containers
import Frontend from '@/containers/FrontEnd'

// Views

// Views - Components


//Views FrontEnd Componentes
import BancoProblemas from '@/views/frontend/BancoProblemas'
import Publicaciones from '@/views/frontend/publicaciones'
import Index from '@/views/frontend/index'
import Herramientas from '@/views/frontend/herramientas'
import Nosotros from '@/views/frontend/sobrenosotros'
import EnlacesInteres from '@/views/frontend/enlacesInteres'
import Proyectos from '@/views/frontend/proyectos'
import Directorio from '@/views/frontend/directorioRevistas'

// Views - Buttons

// Views - Icons

// Views - Notifications

// Views - Pages
import Page404 from '@/views/pages/Page404'
import Page500 from '@/views/pages/Page500'
import Login from '@/views/pages/Login'
import Register from '@/views/pages/Register'

Vue.use(Router)

import {store} from '../storage/storage'

export default new Router({
  mode: 'history', // Demo is living in GitHub.io, so required!
  linkActiveClass: 'open active',
  scrollBehavior: () => ({y: 0}),
  routes: [
    { path: '*', component: Page404 },
    {
      path: '/',
      redirect: '/index',
      name: 'Home',
      component: Frontend,
      children: [
        {
          path: 'index',
          name: 'Index',
          component: Index,
          beforeEnter: changeHeader
        }
      ]
    },
    {
      path: '/',
      redirect: '/banco_problemas',
      name: 'Home',
      component: Frontend,
      children: [
        {
          path: 'banco_problemas',
          name: 'Banco de Problemas',
          component: BancoProblemas,
          beforeEnter: changeHeader
        }
      ]
    },
    {
      path: '/',
      redirect: '/publicaciones',
      name: 'Home',
      component: Frontend,
      children: [
        {
          path: 'publicaciones',
          name: 'Producción Científica',
          component: Publicaciones,
          beforeEnter: changeHeader
        }
      ]
    },
    {
      path: '/',
      redirect: '/Herramientas',
      name: 'Herramientas para Investigadores',
      component: Frontend,
      children: [
        {
          path: 'Herramientas',
          name: 'Herramientas para Investigadores',
          component: Herramientas,
          beforeEnter: changeHeader
        }
      ]
    },
    {
      path: '/',
      redirect: '/sobrenosotros',
      name: 'Sobre Nosotros',
      component: Frontend,
      children: [
        {
          path: 'sobrenosotros',
          name: 'Sobre Nosotros',
          component: Nosotros,
          beforeEnter: changeHeader
        }
      ]
    },
    {
      path: '/',
      redirect: '/enlacesinteres',
      name: 'Enlaces de Interes',
      component: Frontend,
      children: [
        {
          path: 'enlacesinteres',
          name: 'Enlaces de Interes',
          component: EnlacesInteres,
          beforeEnter: changeHeader
        }
      ]
    },
    {
      path: '/',
      redirect: '/proyectos',
      name: 'Proyectos',
      component: Frontend,
      children: [
        {
          path: 'proyectos',
          name: 'Proyectos',
          component: Proyectos,
          beforeEnter: changeHeader
        }
      ]
    },
    {
      path: '/',
      redirect: '/directorio',
      name: 'Directorio de Revistas',
      component: Frontend,
      children: [
        {
          path: 'directorio',
          name: 'Directorio de Revistas',
          component: Directorio,
          beforeEnter: changeHeader
        }
      ]
    },
  ]
})

/***
 * Esta funcion se encarga de modificar el header
 * @param to
 * @param from
 * @param next
 */
function changeHeader(to, from, next) {
  console.log("HOLaaaaaa" + store.state.header.title)
  switch (to.name) {
    case 'Index':
      store.state.header.title = store.state.header.titulos.get('index')
      store.state.header.imagen = store.state.header.imagenes.get('index')
      break;
    case 'Banco de Problemas':
      store.state.header.imagen = store.state.header.imagenes.get('bp')
      store.state.header.imagen = store.state.header.imagenes.get('bp')
      break;
    case 'publicaciones':
      break;
    case 'Herramientas para Investigadores':
      store.state.header.title = store.state.header.titulos.get('herramientas')
      store.state.header.imagen = store.state.header.imagenes.get('herramientas')
      break;
    case 'Nosotros':
      store.state.header.title = store.state.header.titulos.get('nosotros')
      break;
    case 'Directorio de Revistas':
      store.state.header.title = 'directorio'
        store.state.header.imagen = store.state.header.imagenes.get('directorio')
      break;
    case 'Enlaces de Interes':
      store.state.header.imagen = store.state.header.imagenes.get('enlaces')
      break;
    case 'Proyectos':
      store.state.header.imagen = store.state.header.imagenes.get('proyectos')
      break;

  }
  next()
}



// WEBPACK FOOTER //
// ./src/router/index.js